import React from 'react';
import FFLink from './FFLink';
import styles from './Breadcrumbs.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {Array<{label: string, url: string}>} props.links
 * @param {('arrow'|'slash')=} props.separator; add more options via CSS classes
 */
export default function Breadcrumbs({ className, links, separator = 'slash' }) {
  return (
    <nav className={className}>
      <ol className={styles.list}>
        {links.map(({ label, url }) => (
          <li key={label} className={`${styles.listItem} ${styles[separator]}`}>
            <FFLink url={url}>{label}</FFLink>
          </li>
        ))}
      </ol>
    </nav>
  );
}
